import React from 'react';
import { motion } from 'framer-motion';
import { GlobeAltIcon } from '@heroicons/react/24/outline';
import { useLanguage } from '../../contexts/LanguageContext';
import { SUPPORTED_LOCALES } from '../../i18n/utils';
import {
  PUBLIC_CHROME_FIXED_LEFT_CLASS,
  PUBLIC_CHROME_FIXED_RIGHT_CLASS,
  PUBLIC_CHROME_SHELL_CLASS,
  PUBLIC_CHROME_SHELL_COMPACT_CLASS,
  PUBLIC_CHROME_TOGGLE_CLASS,
  PUBLIC_CHROME_TOGGLE_COMPACT_CLASS,
  publicChromeLocaleButtonClass,
} from './publicChromeStyles';

const LOCALE_LABELS = {
  en: 'EN',
  es: 'ES',
};

function PublicLanguageSwitcher({ variant = 'inline', compact = false, fixedAlign = 'right', className = '' }) {
  const { language, changeLanguage, t } = useLanguage();

  const fixedPositionClass =
    fixedAlign === 'left'
      ? PUBLIC_CHROME_FIXED_LEFT_CLASS
      : PUBLIC_CHROME_FIXED_RIGHT_CLASS;

  const wrapperClass =
    variant === 'fixed'
      ? `${fixedPositionClass} ${className}`
      : `shrink-0 ${className}`;

  const shellClass = compact ? PUBLIC_CHROME_SHELL_COMPACT_CLASS : PUBLIC_CHROME_SHELL_CLASS;

  const toggleClass = compact ? PUBLIC_CHROME_TOGGLE_COMPACT_CLASS : PUBLIC_CHROME_TOGGLE_CLASS;

  return (
    <div
      className={wrapperClass}
      role="group"
      aria-label={t.common.languageSwitcher}
    >
      <div className={shellClass}>
        {!compact && (
          <GlobeAltIcon className="h-4 w-4 text-orange-500 shrink-0" aria-hidden />
        )}
        <div className={toggleClass}>
          {SUPPORTED_LOCALES.map((locale) => {
            const active = language === locale;
            return (
              <motion.button
                key={locale}
                type="button"
                whileTap={{ scale: 0.96 }}
                onClick={() => changeLanguage(locale)}
                className={publicChromeLocaleButtonClass(active, compact)}
                aria-pressed={active}
                aria-label={locale === 'en' ? t.settings.languageEn : t.settings.languageEs}
              >
                {LOCALE_LABELS[locale]}
              </motion.button>
            );
          })}
        </div>
      </div>
    </div>
  );
}

export default PublicLanguageSwitcher;
